import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import "./Header.scss";

function Header() {
  const [mobileToggle, setMobileToggle] = useState(false);

  return (
    <div className={`header-wrap ${mobileToggle ? "mobile-open" : ""}`}>
      <div className="container header">
        <div className="logo-wrap">
          <div className="">
            <Fade>
              <Link to="/">
                WowWish<span>Momemts</span>
              </Link>
            </Fade>
          </div>
        </div>
        <div className="menu-wrap">
          <ul>
            <li>
              <Link
                onClick={() => setMobileToggle(!mobileToggle)}
                className="animateLine"
                to="/about"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setMobileToggle(!mobileToggle)}
                className="animateLine"
                to="/services"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setMobileToggle(!mobileToggle)}
                className="animateLine"
                to="/gallery"
              >
                Gallery
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setMobileToggle(!mobileToggle)}
                className="animateLine"
                to="/contact"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setMobileToggle(!mobileToggle)}
                className="btn"
                to="mailto:wowwishMoments@gmail.com?subject=Request a proposal of event"
              >
                Request Proposal
              </Link>
            </li>
          </ul>
        </div>
        <div
          className="toggle-btn"
          onClick={() => setMobileToggle(!mobileToggle)}
        >
          <div>
            <span className="line-1"></span>
            <span className="line-2"> </span>
            <span className="line-3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
